import { VideoModal } from '../components/video_modal.js';

export class Kids extends DrupalBehavior {
  onReady(content) {
    function wysiwyg() {
      var title = document.querySelector('.paragraph--type--wysiwyg h2');
      var body = document.querySelector('.paragraph--type--wysiwyg p');
      wysiwygTimeline
        .from(
          title,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          body,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0.125
        );

      wysiwygTimeline.progress(1).progress(0);

      let wysiwygTarget = document.querySelector('.paragraph--type--wysiwyg');
      io.observe(wysiwygTarget);
    }

    function textImageCTA() {
      var component = document.querySelector('.text-image-cta');
      textImageCTATimeline.from(
        component,
        { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
        0
      );

      textImageCTATimeline.progress(1).progress(0);

      io.observe(component);
    }

    function patientStories() {
      var title = document.querySelector('.patient-stories h2');
      var link = document.querySelector('.patient-stories > a');
      var featured = document.querySelector('.patient-stories--featured');
      var teasers = document.querySelectorAll(
        '.patient-stories .article--teaser'
      );

      patientStoriesTimeline
        .from(
          title,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          link,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.125
        )
        .from(
          featured,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0.25
        )
        .from(
          teasers,
          {
            duration: 1,
            ease: 'power4.out',
            y: 50,
            opacity: 0,
            stagger: 0.125,
          },
          0.375
        );

      patientStoriesTimeline.progress(1).progress(0);

      let patientStoriesTarget = document.querySelector('.patient-stories');
      io.observe(patientStoriesTarget);
    }

    function testimonials() {
      var component = document.querySelector('.testimonials');
      testimonialsTimeline.from(
        component,
        { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
        0
      );

      testimonialsTimeline.progress(1).progress(0);

      io.observe(component);
    }

    function news() {
      var title = document.querySelector('.tagged-articles h2');
      var link = document.querySelector('.tagged-articles > a');
      var teasers = document.querySelectorAll(
        '.tagged-articles .article--teaser'
      );

      newsTimeline
        .from(
          title,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0
        )
        .from(
          link,
          { duration: 1, ease: 'power4.out', yPercent: 100, opacity: 0 },
          0.125
        )
        .from(
          teasers,
          {
            duration: 1,
            ease: 'power4.out',
            y: 50,
            opacity: 0,
            stagger: 0.125,
          },
          0.25
        );

      newsTimeline.progress(1).progress(0);

      let newsTarget = document.querySelector('.tagged-articles');
      io.observe(newsTarget);
    }

    function mobileBanner() {
      var imageWrap = document.querySelector('.mobile-banner--image--wrap');
      var body = document.querySelector('.mobile-banner--body');

      mobileBannerTimeline
        .from(
          imageWrap,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0
        )
        .from(
          body,
          { duration: 1, ease: 'power4.out', yPercent: 25, opacity: 0 },
          0.125
        );

      mobileBannerTimeline.progress(1).progress(0);

      let mobileBannerTarget = document.querySelector('.mobile-banner');
      io.observe(mobileBannerTarget);
    }

    function intersectionHandler(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //WYSIWYG
          if (entry.target.classList.contains('paragraph--type--wysiwyg')) {
            wysiwygTimeline.play();
          }

          //Text Image CTA
          if (entry.target.classList.contains('text-image-cta')) {
            textImageCTATimeline.play();
          }

          //Patient Stories
          if (entry.target.classList.contains('patient-stories')) {
            patientStoriesTimeline.play();
          }

          //Testimonials
          if (entry.target.classList.contains('testimonials')) {
            testimonialsTimeline.play();
          }

          //News
          if (entry.target.classList.contains('tagged-articles')) {
            newsTimeline.play();
          }

          //Mobile Banner
          if (entry.target.className == 'mobile-banner') {
            mobileBannerTimeline.play();
          }
          observer.unobserve(entry.target);
        }
      });
    }

    let wysiwygTimeline = gsap.timeline({ paused: true });
    let textImageCTATimeline = gsap.timeline({ paused: true });
    let patientStoriesTimeline = gsap.timeline({ paused: true });
    let testimonialsTimeline = gsap.timeline({ paused: true });
    let newsTimeline = gsap.timeline({ paused: true });
    let mobileBannerTimeline = gsap.timeline({ paused: true });
    let io = new IntersectionObserver(intersectionHandler);
    wysiwyg();
    textImageCTA();
    patientStories();
    testimonials();
    news();
    mobileBanner();
  }

  onContent(context) {
    var videoModal = new VideoModal();
    var videos = context.querySelectorAll(
      '.article--teaser--video, .featured-article__video'
    );
    videoModal.init(videos);
  }
}

DrupalBehavior.register('rush_theme.pages', 'kids', Kids);
